module.exports = __webpack_public_path__ + "img/ico_kb_type5_01.dbc52cb3.png";